import {prevent_multiple_submission_service} from '../prevent_multiple_submission_service/main'
$(function(){
    common_init_service.page_init();
});

var common_init_service = {
    page_init: function () {
        console.log('common_init_service.page_init start');

        this.apply_data_href('page');
        //this.apply_datatable('page');
        this.apply_datetimepicker('page');
        this.apply_repeater('page');
        //this.apply_balloon('page');
        this.apply_select2('page');
        this.apply_trumbowyg('page');
        this.init_popup_form_service();
        //this.init_upload_form();
        this.init_message_close_button();
        //this.init_custom_file_input('page');
        //this.init_ezine_body_input();
        prevent_multiple_submission_service.init_disablable_button('page');

        console.log('common_init_service.page_init end');
    },

    modal_init: function () {
        console.log('common_init_service.modal_init start');

        this.apply_data_href('modal');
        //this.apply_datatable('modal');
        this.apply_datetimepicker('modal');
        this.apply_repeater('modal');
        //this.apply_balloon('modal');
        this.apply_select2('modal');
        this.apply_trumbowyg('modal');
        this.apply_autokana();
        //this.init_account_input();
        this.init_message_close_button();
        //this.init_custom_file_input('modal');
        this.init_plan_legend();
        prevent_multiple_submission_service.init_disablable_button('modal');

        console.log('common_init_service.modal_init end');
    },

    apply_data_href: function(mode){
        var element = mode == 'modal' ? $('.simple_popup_service_container tr[data-href]') : $('tr[data-href]');
        element.addClass('clicklink').click(function(e) {
            window.location = $(this).attr('data-href');
        });
    },

    apply_datatable: function(mode){
        var element = mode == 'modal' ? $('.simple_popup_service_container .datatable') : $('.datatable');
        element.DataTable({
            "paging": true,
            "lengthChange": true,
            "searching": true,
            "ordering": true,
            "info": true,
            "autoWidth": true,
            "order": [ [ 0, "desc" ] ]
        });
    },

    apply_datetimepicker: function(mode){
        var element1 = mode == 'modal' ? $('.simple_popup_service_container .datepicker') : $('.datepicker');
        element1.each(function() {
            $(this).datetimepicker({
                locale: 'ja',
                format: 'YYYY/MM/DD',
                dayViewHeaderFormat: 'YYYY年 MMMM',
                useCurrent: false,
                showClear: false,
                showTodayButton: false,
                widgetPositioning: {
                    horizontal: $(this).hasClass('picker-position-right') ? "right" : "left",
                    vertical: "auto"
                }
            })
        });

        var element2 = mode == 'modal' ? $('.simple_popup_service_container .timepicker') : $('.timepicker');
        element2.each(function() {
            $(this).datetimepicker({
                format: 'HH:mm',
                useCurrent: false,
                showClear: true,
                widgetPositioning: {
                    horizontal: $(this).hasClass('picker-position-right') ? "right" : "left",
                    vertical: "auto"
                }
            })
        });

        var element3 = mode == 'modal' ? $('.simple_popup_service_container .datetimepicker') : $('.datetimepicker');
        element3.each(function() {
            $(this).datetimepicker({
                format: 'YYYY/MM/DD HH:mm',
                useCurrent: false,
                showClear: true,
                widgetPositioning: {
                    horizontal: $(this).hasClass('picker-position-right') ? "right" : "left",
                    vertical: "auto"
                }
            })
        });
    },

    apply_repeater: function(mode){
        var element = mode == 'modal' ? $('.simple_popup_service_container .repeater') : $('.repeater');
        element.repeater({
            initEmpty: false,
            defaultValues: {
            },
            show: function () {
                $(this).slideDown();
                //event.preventDefault(); FireFoxで動作しないので、HTMLのbutton要素にonclick="return false;"を追加しました
            },
            hide: function (deleteElement) {
                $(this).slideUp(deleteElement);
                //event.preventDefault(); FireFoxで動作しないので、HTMLのbutton要素にonclick="return false;"を追加しました
            },
            isFirstItemUndeletable: false
        });
    },

    apply_balloon: function(mode){
        var element = mode == 'modal' ? $('.simple_popup_service_container .balloon') : $('.balloon');
        element.balloon({classname: 'balloon-comment'});
    },

    apply_select2: function(mode){
        var element = mode == 'modal' ? $('.simple_popup_service_container .select2') : $('.select2');
        element.select2();
    },

    apply_trumbowyg: function(mode){
        var element = mode == 'modal' ? $('.simple_popup_service_container .trumbowyg') : $('.trumbowyg');
        element.trumbowyg({
            svgPath: false,
            btnsDef: {
                // Create a new dropdown
                image: {
                    dropdown: ['insertImage', 'base64']
                }
            },
            btns: [
                ['viewHTML'],
                ['undo', 'redo'], // Only supported in Blink browsers
                ['formatting'],
                ['foreColor','backColor'],
                ['strong', 'em', 'del'],
                ['superscript', 'subscript'],
                ['link'],
                ['image'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                ['unorderedList', 'orderedList'],
                ['horizontalRule'],
                ['removeformat'],
                ['fullscreen']
            ],
            autogrow: true,
            semantic: false // Disable auto p tag insertion
        });
        var fontAwesomeButtons = {
            "trumbowyg-viewHTML-button":        "fa fa-code",
            "trumbowyg-undo-button":            "fa fa-undo",
            "trumbowyg-redo-button":            "fa fa-redo",
            "trumbowyg-formatting-button":      "fa fa-paragraph",
            "trumbowyg-strong-button":          "fa fa-bold",
            "trumbowyg-em-button":              "fa fa-italic",
            "trumbowyg-del-button":             "fa fa-strikethrough",
            "trumbowyg-superscript-button":     "fa fa-superscript",
            "trumbowyg-subscript-button":       "fa fa-subscript",
            "trumbowyg-link-button":            "fa fa-link",
            "trumbowyg-foreColor-button":       "fa fa-font",
            "trumbowyg-backColor-button":       "fa fa-paint-brush",
            "trumbowyg-image-button":           "fa fa-image",
            "trumbowyg-justifyLeft-button":     "fa fa-align-left",
            "trumbowyg-justifyCenter-button":   "fa fa-align-center",
            "trumbowyg-justifyRight-button":    "fa fa-align-right",
            "trumbowyg-justifyFull-button":     "fa fa-align-justify",
            "trumbowyg-unorderedList-button":   "fa fa-list-ul",
            "trumbowyg-orderedList-button":     "fa fa-list-ol",
            "trumbowyg-horizontalRule-button":  "fa fa-minus",
            "trumbowyg-removeformat-button":    "fa fa-eraser",
            "trumbowyg-fullscreen-button":      "fa fa-arrows-alt"
        }
        // Loop through each button, insert an <i> element with the correct class
        $('.trumbowyg-button-pane button').each( function(i,el){
            var btnClass = $(el).attr('class').split(' ')[0];
            var faClass = fontAwesomeButtons[btnClass];
            $(el).html('<i class="'+faClass+'"></i>');
        });
    },
    
    apply_autokana: function(){
        $('.player_name').each(function(_,inputGroup){
            const nameInput = $(inputGroup).children('.autoKana-name').first();
            const kanaInput = $(inputGroup).children('.autoKana-kana').first();
            $.fn.autoKana(nameInput, kanaInput, {katakana: true});
        });
    },

    init_popup_form_service: function(){
        popup_form_service.conf.use_ajax = true;
        popup_form_service.init ();
    },

    init_upload_form: function(){
        const form = document.getElementById('upload_form');
        if (form){
            form.addEventListener('change', setName);

            function setName() {
                const label = document.getElementById('upload_label');
                const file = form.files[0];
                if (file) {
                    label.innerHTML = file.name;
                } else {
                    label.innerHTML = 'Choose file';
                }
            }
        }
    },

    init_account_input: function(){
        $('#account_account_type_id').on('change', function() {
            const type = $(this).val();
            if (type === '1') {
                $('#div_check_permission').show();
                $('#div_select_club').hide();
            } else if (type === '2') {
                $('#div_check_permission').hide();
                $('#div_select_club').show();
            } else {
                $('#div_check_permission').hide();
                $('#div_select_club').hide();
            }
        }).change();
    },

    init_message_close_button: function(){
        $('.message_close_button').on('click', function(){
            $(this).parent('div.alert').hide(200)
        })
    },

    init_custom_file_input: function(mode){
        var element = mode == 'modal' ? $('.simple_popup_service_container input.custom-file-input') : $('input.custom-file-input');
        element.change(function () {
            $(this).next('label').text(this.files[0] == null ? 'Choose file ...' : this.files[0].name)
        });
    },

    init_ezine_body_input: function(){
        $('input[name="ezine[ezine_body_type_id]"]:radio').change(function () {
            const selected_value = $(this).filter(':checked').val();
            if (selected_value === "1"){
                $('div#text_body').show();
                $('div#html_body').hide();
            } else if (selected_value === "2"){
                $('div#text_body').hide();
                $('div#html_body').show();
            } else if (selected_value === "3"){
                $('div#text_body').show();
                $('div#html_body').show();
            }
        }).change();
    },

    init_plan_legend: function(mode){
        var element = mode == 'modal' ? $('.simple_popup_service_container img.icon_help') : $('img.icon_help');
        element.hover(function(){
            $('.plan_detail_icon_legend').show();
        }, function(){
            $('.plan_detail_icon_legend').hide();
        });
    }
};

export {common_init_service};
